/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

'use strict';
const addToCartSingle = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: () => {
		$(document).on('click', '.product-filters-btn', (e) => {
			const _self = $(e.currentTarget);

			if (_self.hasClass('shown')) {
				_self.removeClass('shown').text('Show Filters');
				$('.js-product-listing__side-nav').slideUp();
			} else {
				_self.addClass('shown').text('Hide Filters');
				$('.js-product-listing__side-nav').slideDown();
			}
		});
	}
};

export default addToCartSingle;
